var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"flashnotice"},[_c('h3',[_vm._v(_vm._s(_vm.organization_details.urgent_message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }